<template>
  <div class="upload-img" >
    <a-upload
      :accept="accept"
      list-type="picture-card"
      class="card-uploader "
      :show-upload-list="false"
      :data="uploadData"
      :customRequest="uploadRequest"
    >
      <slot name="default" :loading="uploadData.loading"></slot>
      <!-- 进度条样式 -->
      <slot name="process" :loading="uploadData.loading" :percent="uploadData.percent">
        <div class="process-box" v-if="uploadData.loading">
          <div style="width:70px">
            <div class="process" >
              <div class="wrap-in" :style="{'width':uploadData.percent + '%'} "></div>
            </div>
          </div>
          <span class="num">{{ uploadData.percent+ '%' }}</span>
        </div>
        <div class="close" v-if="uploadData.loading">
          <span class="icon-icon_close_spheric_24" @click.stop="cancelUpload"></span>
        </div>
      </slot>
      <!-- 按钮样式 -->
      <slot name="reset-btn" v-if="uploadData.image">

        <div class="mask" >
          <span
            class="upload-btn"

          >重新选择
          </span>
        </div>
      </slot>
    </a-upload>

    <image-clip

      ref="imageClip"
      :imgFile="imgFile"
      @upload="onClipSuccess"

      :fileName="fileName"
      :clipOption="clipOption"

    >

    </image-clip>

  </div>
</template>

<script>
import { getRandom, getBase64, dataURLtoBlobs, blobToFile } from '@/utils/util.js'
import { mapActions } from 'vuex'
import ImageClip from '@/components/Zpace/clip/ImageClip.vue'
import * as qiniu from 'qiniu-js'
export default {
  components: {
    ImageClip
  },
  props: {
    // type: {
    //   type: String,
    //   default: 'idCard'
    // },
    clipOption: {
      type: Object,
      default: () => {
        return {
          autoCropWidth: 340,
          autoCropHeight: 269,
          fixedNumber: [340, 269]
        }
      }
    },
    clip: {
      type: Boolean,
      default: false
    },
    bucketType: {
      type: String,
      default: '1' //	1:正常图片  2：水印图片  3：私用空间 4. 用户资源
    },
    data: {
      default: () => {
        return {

        }
      },
      type: Object
    },
    path: {
      type: String,
      default: 'resources/cloud/person/'
    },
    bgImg: {
      type: String,
      default: require('../../../assets/img/img_id_card_z_200_125@2x.png')
    },
    limit: {
      type: Number, // 单位 kb
      default: 0
    },
    accept: {
      type: String,
      default: '.jpeg,.png,.jpg'
    },
    checkSize: {
      type: Function,
      default: () => {
        return new Promise((resolve, reject) => {
          resolve('OK')
        })
      }
    }
  },
  data () {
    return {
      showClip: false,
      domainMap: {
        '1': this.constv.QINIU_IMAGE_CND_URL,
        '2': this.constv.QINIU_IMAGE_WATERMARK_CND_URL,
        '3': '',
        '4': this.constv.QINIU_IMAGE_USERRESOURCE_CND_URL
      },
      idCardBase64: '',
      imgFile: '',
      fileName: '',
      observable: {},
      uploadData: Object.assign({
        image: '',
        loading: false,
        percent: 0
      }, this.data)
    }
  },
  methods: {
    ...mapActions(['getQiniuToken']),
    name () {
      return getRandom(4) + Math.floor(new Date().getTime() / 1000) + getRandom(4)
    },
    onClipSuccess (file, fileName) {
      this.postImage(blobToFile(dataURLtoBlobs(file), fileName), fileName)
    },
    async uploadRequest ({ action,
      data,
      file,
      filename,
      headers,
      onError,
      onProgress,
      onSuccess,
      withCredentials }) {
      console.log(file, 'file')
      this.fileName = file.name
      filename = file.name
      const isJpgOrPng = this.accept.split(',').findIndex((item) => {
        return file.name.indexOf(item.replace(/\./g, '')) > -1
      })
      if (isJpgOrPng < 0) {
        this.$message.error(`只能上传${this.accept.replace(/\./g, '').replace(/,/g, '、')}格式的图片`)
        return false
      } else {
        this.uploadData.error = ''
      }

      if (this.limit) {
        const isLimit = file.size / 1024 < this.limit
        if (!isLimit) {
          this.$message.error(`只能上传小于${this.limit > 1000 ? Math.floor(this.limit / 1000) + 'M' : this.limit + 'kb'}的图片`)
          return false
        } else {
          this.uploadData.error = ''
        }
      }

      if (this.clip) {
        getBase64(file, (oimg) => {
          this.imgFile = oimg
          this.$refs.imageClip.showClip = true
        })
      } else {
        // 检查尺寸
        this.checkSize(file, data).then(async res => {
          this.$emit('uploadRequest', { action, data: this.uploadData, file, filename, headers, onError, onProgress, onSuccess, withCredentials })
          this.postImage(file, filename)
        }).catch((e) => {
          console.log(e)
        })
      }
    },
    // 获取后缀名
    geteExtension (url) {
      var ext = null
      var name = url.toLowerCase()
      var i = name.lastIndexOf('.')
      if (i > -1) {
        ext = name.substring(i + 1)
      }
      return ext
    },
    // 上传到七牛
    async postImage (file, filename) {
      const sendData = {
        action: 'upload',
        bucketType: this.bucketType
      }
      // 获取七牛上传token
      await this.getQiniuToken(sendData)

      const params = {
        token: this.$store.state.texture.token,
        key: `${this.path}${this.name()}.${
          this.geteExtension(filename)
        }`
      }
      this.uploadData.image = ''
      this.uploadData.loading = true
      // 上传到七牛 拿到图片地址
      const observable = qiniu.upload(file, params.key, params.token)
      this.observable = observable.subscribe({
        next: (result) => {
          // 主要用来展示进度
          console.log(result.total.percent)
          this.uploadData.percent = Math.floor(result.total.percent)
          if (this.uploadData.percent === 100) {
            this.uploadData.loading = false
          }
        },
        error: () => {
          this.uploadData.loading = false
          this.$emit('onError', this.uploadData)
          this.$message.error('上传失败')
        },
        complete: (response) => {
          this.uploadData.image = response.key // 返回的路径
          this.uploadData.loading = false
          this.uploadData.percent = 0
          this.errTips = ''
          this.$emit('onSuccess', { response, filename, file, data: this.uploadData })
        }
      })
    },
    cancelUpload () {
      this.uploadData.image = ''
      this.uploadData.loading = false
      this.uploadData.percent = 0
      this.$emit('onCancel', this.uploadData)
      this.observable.unsubscribe()
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.uploadData = Object.assign(this.uploadData, val)
      }
    }
  }

}
</script>

<style scoped lang="less">

.upload-img{
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    &:hover {
      .mask {
        display: flex;
        pointer-events: none;
        /deep/
        .upload-btn {
          padding: 0;
          display: flex;
          width: 40px;
          height: 40px;
          word-break: break-all;
          pointer-events: none;
          color: #fff;
          font-size: 12px;
          line-height: 16px;
          justify-content: center;
          align-items: center;
          padding:  0 8px;
          box-sizing: border-box;
        }
      }
    }
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      max-width: 100%;
      border-radius: 4px;
      max-height: 100%;
    }
    .close {
      position: absolute;
      right: -8px;
      top: -8px;
      font-size: 16px;
      color: #CCCCCC;
      display: block;

      span {
        background-color: #fff;
        border-radius: 50%;
        &:hover {
          color: #FF7401;
        }
      }
    }
    .process-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 8px;
      pointer-events: none;
      .num {
        color: @primary-color;
        margin-left: 5px;
      }
      .process {
        width: 100%;
        border-radius: 8px;
        border:1px solid @primary-color;
        padding: 0 5px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        height: 16px;
        .wrap-in {
          width: 20%;

          border-radius: 4px;
          height: 8px;
          background-color: @primary-color;
        }
      }
    }
    .mask {
      pointer-events: none;
        display: none;
        position: absolute;
        border-radius: 4px;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 116, 1, 0.8);

        justify-content: center;
        align-items: center;
    }
    /deep/
    .card-uploader > .ant-upload {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      overflow: hidden;
    }
    /deep/
    .ant-upload.ant-upload-select-picture-card > .ant-upload{
      border-radius: 8px;
      padding: 0;
    }
    /deep/
    .ant-upload.ant-upload-select-picture-card{
      border:none
    }
    /deep/
    .ant-upload.ant-upload-select-picture-card {
      background: none;
    }
    /deep/
    .ant-upload-picture-card-wrapper {
      height: 100%;
    }

}
</style>
